






































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { IRole, IUser, UserModel, UserRoleType } from 'admiral-core';
import { ArrowLeftIcon, ArrowRightIcon, PlusIcon, XIcon } from 'vue-feather-icons';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';
import { FormMixin } from '@/mixins/FormMixin';
import FormSubmit from '@/components/common/forms/FormSubmit.vue';
import UserForm from '@/forms/UserForm.vue';
import { UserApi } from '@/services/UserApi';
import { BModal } from 'bootstrap-vue';
import DeleteUserModal from '@/views/pages/settings/agency/DeleteUserModal.vue';

@Component({
  components: {
    DeleteUserModal,
    UserForm,
    FormSubmit,
    ArrowLeftIcon,
    ArrowRightIcon,
    PlusIcon,
    XIcon,
  },
})
export default class EditUserModal extends mixins(FormMixin, BaseMixin) {
  @Prop({ required: true, type: Object })
  selectedUser!: IUser;

  model = this.defaultModel();

  defaultModel(): UserModel {
    return {
      ...this.selectedUser,
      password: '',
      emailText: '',
    };
  }

  async mounted() {
    this.resetModel();
  }

  @Watch('selectedUser')
  watchSelectedUser() {
    this.model = {
      ...this.selectedUser,
      password: '',
    };
  }

  async ok(evt: Event) {
    evt.preventDefault();
    try {
      this.isLoading = true;

      await UserApi.update(this.model.id!, {
        agency: this.agency,
        email: this.model.email!,
        firstname: this.model.firstname!,
        lastname: this.model.lastname!,
        role: this.model.role!,
        type: this.model.type!,
        group: this.model.group!,
        status: this.model.status!,
        password: this.model.password,
        emailText: this.model.emailText || '',
      });
      this.$toastr.s(
        `${this.model.firstname} ${this.model.lastname} erfolgreich bearbeitet.`,
        'Mitarbeiter bearbeitet',
      );
      this.$nextTick(() => {
        (this.$refs['edit-user'] as BModal).hide();
      });

      this.$emit('reload');
    } catch (e) {
      const apiErrors = this.exceptionErrors(e);

      this.errorHandling(apiErrors);
      this.$toastr.e('Beim Speichern des Mitarbeiters ist etwas schief gelaufen.', 'Oops');
    } finally {
      this.isLoading = false;
    }
  }

  errorHandling(apiErrors: Record<string, string>) {
    this.addError(
      apiErrors['firstnameminLength'],
      'firstname',
      'Bitte einen gültigen Vornamen angeben.',
    );

    this.addError(
      apiErrors['lastnameminLength'] || apiErrors['lastnameisNotEmpty'],
      'lastname',
      'Bitte einen gültigen Nachnamen angeben.',
    );

    this.addError(apiErrors['emailisEmail'], 'email', 'Bitte eine gültige E-Mail Adresse angeben.');

    this.addError(apiErrors['typeisNotEmpty'], 'type', 'Bitte eine Gruppe auswählen.');

    this.addError(
      apiErrors['UserAlreadyExists'],
      'email',
      'Es existiert bereits ein Mitarbeiter mit dieser E-Mail Adresse.',
    );
  }

  cancel() {
    this.resetModel();
  }

  resetModel() {
    this.model = this.defaultModel();
    this.model.role = this.roles.find((role: IRole) => role.type === UserRoleType.EMPLOYEE);
  }

  deleted() {
    this.$nextTick(() => {
      (this.$refs['edit-user'] as BModal).hide();
    });
    this.$emit('reload');
  }

  reload() {
    //
  }

  get hasEmailChanged() {
    return this.model.email !== this.selectedUser.email;
  }

  get isGuestUser() {
    return this.model.role?.type === UserRoleType.GUEST;
  }
}
